import { Collections, PopularShows } from '../../types/config';
import { CouponItem, Packages } from '../../web-shared/types/billing';

export interface ConfigState {
  collections: Collections;
  contentCollections?: Record<'tvShows' | 'movies', Collections>;
  coupon?: CouponItem;
  couponList?: CouponItem[];
  doNotSell?: boolean;
  eduEmail?: string;
  experiments: Record<string, string>;
  imageCDNBaseURL: string;
  isEduAuthentication?: boolean;
  isEduWithMobile?: boolean;
  isMobileDevice: boolean;
  isUserLoggedIn: boolean;
  loginRedirectReason?: string;
  popular: PopularShows;
  preferredBasePrice: string;
  preferredChannelCount: string;
  redirectURL: string;
  sendConfirmLink: boolean;
  sendToken: boolean;
  showCouponPrompt: boolean;
  stripeKey: string;
  track: string;
  version: string;
  addonPriceChangeDetails?: {
    announcementDate: string;
    effectiveDate: string;
    newPriceCents: number;
    productId: Packages;
  };
}

const initialState: ConfigState = {
  collections: [],
  doNotSell: false,
  experiments: {},
  imageCDNBaseURL: 'https://static-us-east-2-fastly-a.www.philo.com',
  isMobileDevice: false,
  isUserLoggedIn: false,
  popular: [],
  preferredBasePrice: '$28',
  preferredChannelCount: '70+',
  redirectURL: '',
  sendConfirmLink: false,
  sendToken: true,
  showCouponPrompt: false,
  stripeKey: '',
  track: '',
  version: '',
};

export default initialState;
